import { render, staticRenderFns } from "./mobileAccount.vue?vue&type=template&id=2c2fc0be&scoped=true&"
import script from "./mobileAccount.vue?vue&type=script&lang=js&"
export * from "./mobileAccount.vue?vue&type=script&lang=js&"
import style1 from "./mobileAccount.vue?vue&type=style&index=1&id=2c2fc0be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2fc0be",
  null
  
)

export default component.exports